import { useGSAP } from "@gsap/react"
import clsx from "clsx"
import gsap from "gsap"
import { FC, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useGame } from "@/providers/GameProvider"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./ChangeTurnPopup.module.scss"

interface IChangeTurnPopup {}

export const ChangeTurnPopup: FC<IChangeTurnPopup> = () => {
  const { t } = useTranslation()
  const { isMyTurn, refGameState } = useGame()

  const [isMyTurnTrigger, setIsMyTurnTrigger] = useState<boolean>(isMyTurn)

  const refRoot = useRef<HTMLDivElement>(null)

  useGSAP(() => {
    if (!refGameState.current) return

    gsap.killTweensOf(refRoot.current)

    gsap
      .timeline()
      .fromTo(
        refRoot.current,
        {
          autoAlpha: 0,
          scale: 0.3
        },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.5,
          ease: "power2.out"
        }
      )
      .delay(0.5)
      .to(refRoot.current, {
        autoAlpha: 0,
        scale: 1.3,
        duration: 0.3,
        ease: "power2.inOut"
      })
  }, [isMyTurnTrigger])

  useEffect(() => {
    if (isMyTurn !== isMyTurnTrigger) {
      setIsMyTurnTrigger(isMyTurn)
    }
  }, [isMyTurn])

  return (
    <div
      className={clsx(styles.ChangeTurnPopup, isMyTurn && styles.isMyTurn)}
      ref={refRoot}
    >
      <OutlinedText className={clsx(styles.ChangeTurnPopup_title)}>
        {isMyTurn ? t("yourTurn") : t("rivalTurn")}
      </OutlinedText>
    </div>
  )
}
